import readCookie from '@utils/read-cookie';
import readSubcookie from '@utils/read-subcookie';
import * as React from 'react';
import { Helmet } from 'react-helmet';

const Mutiny = (): JSX.Element => {
  return (
    <Helmet>
      <script src="https://client-registry.mutinycdn.com/personalize/client/b20024ac5582424c.js"></script>
      <script>{`
        window.addEventListener('load', function() {
          const readCookie = ${readCookie};
          const readSubcookie = ${readSubcookie};
          const optanonCookie = readCookie('OptanonConsent');
          if (optanonCookie) {
            const groups = readSubcookie(optanonCookie, 'groups');
            if (groups && groups.match(/funcs:([0-1])/)[1] === '0') {
              window.mutiny.client.optOut();
              return;
            }
          }
        })
      `}</script>
    </Helmet>
  );
};

export default Mutiny;
